import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormControl } from "@angular/forms";
import { ModalController } from "ionic-angular";
import { Utilities } from "../../providers/utilities";

@Component({
  selector: "app-color",
  templateUrl: "color.html",
})
export class ColorComponent {

  @Input() public form: FormControl;
  @Output() public colorChange = new EventEmitter();

  constructor(
    private modalCtrl: ModalController,
    private utilities: Utilities,
  ) {}

  public openModal() {
    const modal = this.modalCtrl.create("ColorPage");
    modal.present();
    modal.onDidDismiss((data) => {
      this.utilities.consoleDecorator("Color selected", data);
      if (data) {
        this.form.setValue(data.color);
        this.colorChange.emit(data.color);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/color/color.ts